import { Type } from '@angular/core';

/**
 * The portal shell and its default page, shared by `app.routes.ts` and `authGuard`. The router
 * loads a component only after its guards, and `authGuard` waits for Firebase plus the login GET,
 * so the guard starts both imports first; the route's own `loadComponent` then resolves from the
 * same request (the module loader dedupes).
 */
export const loadPortalShell = (): Promise<Type<unknown>> =>
  import('./core/layout/portal-shell.component').then((c) => c.PortalShellComponent);

export const loadDashboardPage = (): Promise<Type<unknown>> =>
  import('./features/dashboard/pages/dashboard-page/dashboard-page.component').then((c) => c.DashboardPageComponent);
